import * as v from "valibot";
import { ArticleIdeaStatus } from "../../models/article";
import { pageRequest, pageResponse } from "../paging.dto";
import { aliasField } from "../shared.dto";

export const IDEA_STATUSES: ArticleIdeaStatus[] = Object.values(ArticleIdeaStatus);

export const ideaStatusDto = v.picklist(IDEA_STATUSES);

export const adminIdeaDto = v.object({
  authorAlias: v.string(),
  id: v.string(),
  title: v.string(),
  description: v.string(),
  keyPoints: v.array(v.object({ title: v.string(), description: v.string() })),
  articleId: v.optional(v.string()),
  aiModel: v.string(),
  status: ideaStatusDto,
  createdAt: v.number(),
  updatedAt: v.number(),
});
export type AdminIdea = v.InferOutput<typeof adminIdeaDto>;

/** At least one of `status` and `author` is required: an unfiltered list of every idea is not a screen. */
export const listAdminIdeasRequest = {
  status: v.optional(ideaStatusDto),
  author: v.optional(aliasField),
  ...pageRequest,
};

export const listAdminIdeasResponse = {
  ideas: v.array(adminIdeaDto),
  ...pageResponse,
};

export const resetAdminIdeasRequest = {
  ideas: v.pipe(v.array(v.object({ authorAlias: aliasField, id: aliasField })), v.minLength(1), v.maxLength(100)),
};

export const resetAdminIdeasResponse = { updated: v.number() };

export const deleteAdminAuthorIdeasRequest = { alias: aliasField };

export const deleteAdminAuthorIdeasResponse = { deleted: v.number() };
